export default __webpack_public_path__ + "static/media/JP_News.faadf507.jpg";